import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

interface ClipDetail {
  label: string;
  value: string;
}

interface ClipDetailsCardProps {
  details: ClipDetail[];
}

export function ClipDetailsCard({ details }: ClipDetailsCardProps) {
  const { theme } = useUnistyles();

  return (
    <View bg="surface" borderWidth={1} borderColor="border" rounded={theme.spacing.xl} mb="xl">
      {details.map((detail, index) => (
        <View
          key={detail.label}
          p="lg"
          style={
            index < details.length - 1 ?
              {
                borderBottomWidth: 1,
                borderBottomColor: theme.colors.border as string,
              }
            : undefined
          }
        >
          <Text textStyle="sm/regular" color="textMuted" mb="xs">
            {detail.label}
          </Text>
          <Text textStyle="md/semibold">{detail.value}</Text>
        </View>
      ))}
    </View>
  );
}
